import React from 'react';
import classNames from 'classnames';
import { makeStyles, Tooltip, PopperPlacementType } from '@material-ui/core';
import { Caption } from 'components/Typography/Typography';
import Info from '@material-ui/icons/InfoOutlined';
import styles from 'assets/jss/material-dashboard-pro-react/components/customTooltipStyle';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

//@ts-ignore
const useStyles = makeStyles(styles);

interface ICustomTooltip {
	children: React.ReactElement | string;
	placement?: PopperPlacementType;
	size?: 'sm' | 'md';
	className?: string;
}

const CustomTooltip = ({ children, placement = 'right', size = 'md', className }: ICustomTooltip) => {
	const classes = useStyles();
	return (
		<Tooltip
			arrow
			placement={placement}
			classes={{ tooltip: className }}
			title={
				<div className={classes.tooltip}>
					<ConditionalRender
						show={typeof children === 'string'}
						onTrue={() => (
							<Caption color="primary-dark" disableMargin>
								{children}
							</Caption>
						)}
						onFalse={() => <>{children}</>}
					/>
				</div>
			}
		>
			<Info className={classNames(classes.info, classes[`info${size.toUpperCase()}`])} />
		</Tooltip>
	);
};

export default CustomTooltip;
